import * as React from 'react';
import classNames from 'classnames';

import { useDeviceCondition } from '../../../../../../../../hooks';

import * as styles from './PromotionWarningWrapper.css';

interface IProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

export const PromotionWarningWrapper = ({ icon, children }: IProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      <div className={styles['icon']}>{icon}</div>
      <div className={styles['children']}>{children}</div>
    </div>
  );
};
